module.exports = __webpack_public_path__ + "static/media/image.7e557417.svg";